import { Components } from '@mui/material';

type ReturnType = Record<'MuiFormHelperText', Components['MuiFormHelperText']>;

export default function FormHelperText(): ReturnType {
  return {
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginBlockStart: 0,
        },
      },
    },
  };
}
